import ProductCreate from '_modules/product/views/ProductCreate.vue';
import ProductEdit from '_modules/product/views/ProductEdit.vue';
import ProductList from '_modules/product/views/ProductList.vue';
import ProductPrices from '_modules/product/views/ProductPrices.vue';
import Product from './Root.vue';

export default {
  path: 'produtos/',
  component: Product,
  name: 'admin-product',
  redirect: '/produtos/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-product-list',
      component: ProductList,
    },
    {
      path: 'novo/',
      name: 'admin-product-new',
      component: ProductCreate,
    },
    {
      path: 'precos/:page',
      name: 'admin-product-update-price',
      component: ProductPrices,
    },
    {
      path: ':productId/:page',
      name: 'admin-product-edit',
      component: ProductEdit,
    },
  ],
};
